import { useState } from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AlertTriangle } from "lucide-react";

export const ResetConfirmDialog = ({ open, onOpenChange, onConfirm, count }) => {
  const [text, setText] = useState("");
  const ok = text.trim().toUpperCase() === "CLEAR";

  const handleConfirm = () => {
    if (!ok) return;
    onConfirm();
    setText("");
  };

  return (
    <AlertDialog open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) setText(""); }}>
      <AlertDialogContent data-testid="reset-confirm-modal" className="bg-card border-border">
        <AlertDialogHeader>
          <div className="flex h-11 w-11 items-center justify-center rounded-full bg-destructive/15 mb-1">
            <AlertTriangle className="h-5 w-5 text-destructive" />
          </div>
          <AlertDialogTitle className="font-heading text-slate-50">
            Clear entire inventory?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-muted-foreground">
            This permanently deletes all <span className="font-semibold text-slate-200">{count}</span> items
            from the database and local storage. Type <span className="font-mono font-semibold text-destructive">CLEAR</span> to confirm.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <Input
          data-testid="reset-confirm-input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Type CLEAR"
          className="bg-secondary/40 border-border font-mono"
          onKeyDown={(e) => e.key === "Enter" && handleConfirm()}
        />
        <AlertDialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            data-testid="reset-confirm-submit-button"
            disabled={!ok}
            onClick={handleConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90 disabled:opacity-40"
          >
            Delete everything
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
